import { type FC } from "react";

import hostedLens from "@app-assets/svg/hosted-lens-illustration.svg";

import { EmptyFeaturePage } from "../../core/components";

import { Body, ButtonWrapper, Disclaimer, EmptyHostedLensSvg, EmptyTitle } from "./EmptyHostedLens.styles";
import { HostedLensBody, HostedLensCTA, HostedLensDisclaimer, HostedLensEmptyTitle } from "./messages.generated";

export const EmptyHostedLens: FC<{ generateCTA: React.ReactNode }> = ({ generateCTA }) => {
    return (
        <EmptyFeaturePage icon={<EmptyHostedLensSvg src={hostedLens} />}>
            <EmptyTitle>
                <HostedLensEmptyTitle />
            </EmptyTitle>
            <Body>
                <HostedLensBody />
            </Body>
            <Body>
                <HostedLensCTA />
            </Body>
            <Disclaimer>
                <HostedLensDisclaimer />
            </Disclaimer>
            <ButtonWrapper>{generateCTA}</ButtonWrapper>
        </EmptyFeaturePage>
    );
};
